import React from 'react'
import { Add as AddIcon } from '@mui/icons-material'

import IconLabelButton, { IconLabelButtonProps } from './IconLabelButton'

const PlusButton = (props: Omit<IconLabelButtonProps, 'Icon'>) => (
  <IconLabelButton {...props} Icon={AddIcon} />
)

export default PlusButton
